export const iconFontAwesomeSportsFitnessHeartPulse = (
	<i className="fa-solid fa-heart-pulse"></i>
);
